import React, { useEffect, useRef, useState } from 'react';

const NotificationBanner = ({ 
  show, 
  message, 
  onDismiss, 
  backgroundColor = "#ff9800", 
  icon = "⚠️",
  minShowTime = 3000
}) => {
   const [displayMinTime, setDisplayMinTime] = useState(false);
   const minShowTimeoutRef = useRef();

   useEffect(() => {
    clearTimeout(minShowTimeoutRef.current);
    if (show) {
        setDisplayMinTime(true);
    }
    minShowTimeoutRef.current = setTimeout(() => {
        setDisplayMinTime(false);
    }, minShowTime);
   }, [show, minShowTime]);

   useEffect(() => {
    return () => {
        clearTimeout(minShowTimeoutRef.current);
    };
   }, []);
  if (!show && !displayMinTime) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        backgroundColor,
        color: "white",
        padding: "12px 16px",
        textAlign: "center",
        zIndex: 99998,
        fontSize: "14px",
        fontWeight: "500",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "8px"
      }}
    >
      <span>
        {icon} {message}
      </span>
      <button
        aria-label="Dismiss notification banner"
        onClick={() => {
            onDismiss();
            setDisplayMinTime(false);
        }}
        style={{
          background: "none",
          border: "none",
          color: "white",
          fontSize: "18px",
          fontWeight: "bold",
          cursor: "pointer",
          padding: "0",
          marginLeft: "8px",
          lineHeight: "1",
          opacity: "0.8"
        }}
        onMouseEnter={(e) => e.target.style.opacity = "1"}
        onMouseLeave={(e) => e.target.style.opacity = "0.8"}
      >
        ×
      </button>
    </div>
  );
};

export default NotificationBanner;
